import { render, staticRenderFns } from "./AddPaymentMode.vue?vue&type=template&id=95ca2dba&"
import script from "./AddPaymentMode.vue?vue&type=script&lang=js&"
export * from "./AddPaymentMode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports